/**
 * List all possible events we track
 */
export enum CommunicationSessionEventLogDialPhoneCallType {
  asyncServiceRequestDelivery = 'asyncServiceRequestDelivery',
  dialConference = 'dialConference',
  reservationOffer = 'reservationOffer',
}
